import { render, staticRenderFns } from "./UserEventVkBanner.vue?vue&type=template&id=44130733"
import script from "./UserEventVkBanner.vue?vue&type=script&lang=ts"
export * from "./UserEventVkBanner.vue?vue&type=script&lang=ts"
import style0 from "./UserEventVkBanner.vue?vue&type=style&index=0&id=44130733&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserEventVkBtn: require('/builds/project/wyffest/frontend/components/user/event/vk/UserEventVkBtn.vue').default})
